<template>
  <div class="container">
    <header :style="headerStyle" />
    <section class="form">
      <div v-if="title">
        <div class="title"><h3>{{ title }}</h3></div>
        <div v-if="remark" class="description">{{ remark }}</div>
        <hr>
        <v-form-render ref="vFormRef" :form-json="formJson" :form-data="formData" :option-data="optionData" />
        <el-button type="primary" @click="submitForm">提交</el-button>
      </div>
      <div v-else-if="!loading" class="empty">表单不存在~！🤣 </div>
    </section>
  </div>
</template>
<script>
import bannerImg from '@/assets/images/form-banner.png'
import wx from 'weixin-js-sdk';
import { jsdkSignature, getForm, saveForm } from '@/api/customer';
export default {
  data() {
    return {
      headerStyle: {
        backgroundImage: `url(${bannerImg})`
      },
      formId: '',
      title: '',
      remark: '',
      /* 注意：formJson是指表单设计器导出的json，此处演示的formJson只是一个空白表单json！！ */
      formJson: {},
      formData: {},
      optionData: {},
      loading: true
    }
  },
  async created() {
    this.formId = this.$route.query.id
    if (!this.formId) {
      this.$message.error('表单不存在');
    }
    this.getFormConfig()
  },
  methods: {
    async getFormConfig() {
      this.loading = true;
      const { statusCode, data } = await getForm({
        id: this.formId
      });
      if (statusCode === 0) {
        this.title = data.name
        this.remark = data.remark
        this.formJson = data.form_json
        this.$set(this.headerStyle, 'backgroundImage', `url(${data.cover})`)

        // 微信订阅-分享
        if (this.isWechat()) {
          this.setWXShareConfig(data)
        }
      } else {
        this.$message.error('表单不存在');
      }
      this.loading = false;
    },
    submitForm() {
      this.$refs.vFormRef
        .getFormData()
        .then((formData) => {
          const params = {
            "form_id": this.formId,
            "form_data": JSON.stringify(formData)
          }
          saveForm(params).then(res => {
            if (res.statusCode === 0) {
              this.$msgbox({
                title: '报名成功',
                message: '您已成功提交报名信息，我们会尽快联系您。请勿重复提交。'
              }).then(() => {
                this.closePage()
              });
            } else {
              this.$message.error(res.message)
            }
          }).catch(() => {
            this.$message.error('发生错误')
          })
        })
        .catch((error) => {
          // Form Validation failed
          this.$message.error(error)
        })
    },
    closePage() {
      if (this.isWechat()) {
        this.closePageWx()
      } else {
        window.opener = null
        window.open('about:blank', '_self')
        window.close()
      }
    },
    // 微信内置浏览器关闭
    closePageWx() {
      setTimeout(function() {
        if (typeof window.WeixinJSBridge === "object" && typeof window.WeixinJSBridge.invoke === "function") {
          window.WeixinJSBridge.invoke('closeWindow', {}, function(res) {
            if (res.err_msg === "close_window:ok") {
              // 关闭成功的处理
              console.log('关闭成功')
            } else {
              // 关闭失败的处理
              console.log('关闭失败')
            }
          });
        }
      }, 100);
    },
    // 判断环境
    isWechat() {
      var ua = window.navigator.userAgent.toLowerCase();
      if (ua.match(/micromessenger/i) == 'micromessenger') { // eslint-disable-line
        return true;
      } else {
        return false;
      }
    },
    async setWXShareConfig(data) {
      const { data: wxData } = await jsdkSignature({ url: location.href });
      wx.config({
        debug: false,
        appId: wxData.appId,
        timestamp: wxData.timestamp,
        nonceStr: wxData.nonceStr,
        signature: wxData.signature,
        jsApiList: [ // 这里是需要用到的接口名称
          'checkJsApi', // 判断当前客户端版本是否支持指定JS接口
          'updateAppMessageShareData', // 分享
          'updateTimelineShareData', // 分享朋友圈
          'getLocation', // 获取位置
          'openLocation', // 打开位置
          'scanQRCode', // 扫一扫接口
          'chooseWXPay', // 微信支付
          'chooseImage', // 拍照或从手机相册中选图接口
          'previewImage', // 预览图片接口
          'uploadImage' // 上传图片
        ],
        openTagList: ["wx-open-subscribe"], // 必填，需要使用的JS接口列表
      });
      wx.ready(() => {
        wx.updateAppMessageShareData({
          title: data.name,
          desc: data.remark,
          link: location.href,
          imgUrl: 'https://info.wqserver.com/uploads/images/shareImage.png',
          success: function() {
            // 设置成功
            console.log('分享至聊天窗口成功');
          },
          fail: function() {
            console.log('分享至聊天窗口失败');
          }
        });
        // 分享到朋友圈及分享到QQ空间
        wx.updateTimelineShareData({
          title: data.name,
          desc: data.remark,
          link: location.href,
          imgUrl: 'https://info.wqserver.com/uploads/images/shareImage.png',
          success: function() {
            // 设置成功
            console.log('分享朋友圈成功');
          },
          fail: function() {
            console.log('分享朋友圈失败');
          }
        });
      });
    }
  },
}
</script>
<style lang="less" scoped>
.container{
  min-height:100vh;
  margin:0;
  padding:0;
  position:relative;

  header{
    display: flex;
    justify-content: center;
    min-width: 1200px;
    height: 424px;
    background-image: url("~@/assets/images/backgrounds/form/form-bg.png");
    background-repeat: no-repeat;
    background-position: center center;
    background-size: auto 100%;

    @media screen and (max-width: 1200px) {
      min-width: 0;
      width: 100%;
      height: 200px;
    }
  }
  .form{
    position: relative;
    transform: translateY(-80px);
    width: 1200px;
    margin: 0 auto;
    background-color: #fff;
    padding: 100px 50px;
    border-top-right-radius: 100px;
    min-height: 700px;
    box-shadow: 0px 0px 20px 0px rgba(0, 0, 0, 0.1);

    @media screen and (max-width: 1200px) {
      width: calc(100% - 16px);
      padding: 50px 20px;
      border-top-right-radius: 40px;
      transform: translateY(-32px);
    }

    .title{
      margin-bottom: 16px;
      text-align: center;
      h3{
        color: #000000;
        font-size: 30px;
      }
    }
    .description{
      margin-bottom: 32px;
      text-align: center;
      font-size: 16px;
      color: #737278;
    }
    hr{
      background-color: #1952FF;
      height: 4px;
      margin-bottom: 50px;
    }
    .empty{
      color: #737278;
      font-size: 26px;
      text-align: center;
      line-height: 20;
    }

    ::v-deep {
      .el-form-item__label {
        white-space: pre-line;
        font-weight: bold;
        line-height: 1.2;
        padding: 16px 0;
      }
      .el-checkbox {
        padding: 8px 0;
        display: inline-flex !important;
        align-items: center;

        @media screen and (max-width: 1200px) {
          display: flex !important;
        }

        .el-checkbox__label {
          white-space: normal;
        }
      }
      .upload-file-list {
        display: flex;
        align-items: center;

        .upload-file-name {
          flex: 1;
        }
      }
    }
  }

  .el-button--primary{
    margin-top: 50px;
    background-color: #1952FF;
    border-color:#1952FF;
    width: 100%
  }
}
</style>
